<div *ngIf="form" class="design-revision-liability-judgement__container">
    <div class="design-revision-liability-judgement__liability-container">
        <ng-container *ngFor="let i of liabilityOptions">
            <p-radioButton
                [label]="i.displayName"
                [value]="i.id"
                name="liabilityOptions"
                [formControl]="form.controls.liability"
            />
        </ng-container>
    </div>

    <div
        class="mt-3 design-revision-liability-judgement__reasons-container"
        *ngIf="form.controls.liability.value !== TreatmentDesignRevisionLiability.pending"
    >
        <p-dropdown
            class="w-100"
            [options]="revisionReasons"
            [optionLabel]="'content'"
            optionValue="id"
            [formControl]="form.controls.reasonId"
            appendTo="body"
        />
    </div>

    <div class="mt-3 design-revision-liability-judgement__reasons-container">
        <textarea rows="3" pInputTextarea [autoResize]="true" [formControl]="form.controls.revisionReasonText"
            [style.max-height]="'100px'" class="w-100" placeholder="请输入修改原因" maxlength="50">
        </textarea>
    </div>
</div>
